import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "hero is-fullheight" }
const _hoisted_3 = { class: "hero-head" }
const _hoisted_4 = { class: "navbar" }
const _hoisted_5 = { class: "navbar-brand" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: "/logo.png",
  alt: "Logo"
}, null, -1)
const _hoisted_7 = { class: "navbar-end" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"hero-body\"><div class=\"container has-text-white has-text-weight-light\"><p class=\"title is-size-1 has-text-white\">Empower Campaigns to</p><p class=\"title is-size-1 has-text-white\">Find and Reach their Audiences</p><p class=\"subtitle is-size-3 mt-4\"><span class=\"has-text-weight-light\" style=\"display:block;\">Omni-Channel Mass Communications Platform</span></p><a href=\"https://calendly.com/michael-link2tek\" target=\"_blank\"><button class=\"button mt-4 is-outlined is-white\"><span>Schedule a Demo</span><span class=\"icon\"><i class=\"fas fa-arrow-right\"></i></span></button></a></div></div>", 1)
const _hoisted_9 = { class: "section" }
const _hoisted_10 = { class: "pt-6 mb-6 pb-6" }
const _hoisted_11 = { class: "mt-6 pt-6 mb-6 grey-section" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "p-5 mb-6 primary-section" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "has-text-weight-light has-text-centered has-text-white is-size-2" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Over "),
    /*#__PURE__*/_createElementVNode("span", { class: "has-text-weight-normal" }, "4 Billion "),
    /*#__PURE__*/_createElementVNode("span", null, "Messages Delivered to Date")
  ])
], -1)
const _hoisted_13 = { class: "pb-6 pt-6 mb-6" }
const _hoisted_14 = { class: "pb-6 mt-6 pt-6 mb-6 grey-section" }
const _hoisted_15 = { class: "pt-6 mb-6 pb-6" }
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"primary-section has-text-white\"><div><div class=\"mb-4 is-size-2\">Take the next step</div><a href=\"https://calendly.com/michael-link2tek\" target=\"_blank\"><button class=\"button mt-4 is-outlined is-white\"><span>Schedule a Demo</span><span class=\"icon\"><i class=\"fas fa-arrow-right\"></i></span></button></a></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AboutView = _resolveComponent("AboutView")!
  const _component_ReportingPlatform = _resolveComponent("ReportingPlatform")!
  const _component_DeliveryAI = _resolveComponent("DeliveryAI")!
  const _component_ResultsReportingChart = _resolveComponent("ResultsReportingChart")!
  const _component_ThreeExamples = _resolveComponent("ThreeExamples")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              class: "navbar-item",
              to: {name: 'home'}
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_router_link, {
              class: "navbar-item",
              tag: "a",
              to: {name: 'contact'}
            }, {
              default: _withCtx(() => [
                _createTextVNode("Contact Us")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _hoisted_8
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_AboutView)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_ReportingPlatform)
      ]),
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_DeliveryAI)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_ResultsReportingChart)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_ThreeExamples)
      ]),
      _hoisted_16
    ])
  ]))
}